export default {
  // Reset Password Form
  setNewPassword: 'Set New Password',
  newPassword: 'New password',
  confirmNewPassword: 'Confirm new password',
  forgotPassword: 'Forgot password?',
  passwordRequirementsTitle: 'New Password Requirements',
  passwordRequirementsIntro: 'The new password must:',
  passwordReqLength: 'Be at least 12 characters long',
  passwordReqNumber: 'Include a number',
  passwordReqLowercase: 'Include a lowercase letter',
  passwordReqUppercase: 'Include an uppercase letter',
  passwordReqSpecial: 'Include a special character',
  passwordReqSpecialChars: '(#, ?, !, @, $, %, ^, *, -)',
  checkEmailForReset: 'Check your e-mail for password reset instructions.',
  ok: 'OK',
  resetPassword: 'Reset password',
  enterYourEmail: 'Enter your e-mail',
  cancel: 'Cancel',
  sendResetEmail: 'Send reset e-mail',

  // Password Dialog (logged in)
  setANewPassword: 'Set a new password',
  currentPassword: 'Current password',
  repeatNewPassword: 'Repeat new password',
  proceed: 'Proceed',
  forgotCurrentPassword: 'Forgot current password? (will send you an email)',
  passwordResetEmailSent: 'You will receive an e-mail with instructions for resetting your password in the next minutes.',

  // Terms & Conditions
  termsAndConditions: 'Terms & Conditions',
  termsTitle: 'Terms and Conditions of Use',
  termsSection1Title: '1. Definitions',
  termsSection1User: '"User" means an employee of a company that has entered into a contract with NoiseGrasp for access to the Services.',
  termsSection1Services: '"Services" means the Marketing Mix Modeling platform, related tools, software, and all associated functionalities provided by NoiseGrasp.',
  termsSection2Title: '2. Acceptance of Terms',
  termsSection2Content: 'By accessing and using the Services, the User accepts and agrees to be bound by the terms and provisions of this agreement. Access to the Services is provided under the contract between the User\'s company and NoiseGrasp.',
  termsSection3Title: '3. Restrictions',
  termsSection3Intro: 'The User shall not (and shall not authorize any third party to):',
  termsSection3Item1: 'modify, translate, reverse engineer, decompile, disassemble, or create derivative works based on the Services except to the extent that enforcement of the foregoing restriction is prohibited by applicable law;',
  termsSection3Item2: 'circumvent any limits or other timing, use or functionality restrictions built into the Services;',
  termsSection3Item3: 'remove any proprietary notices, labels, or marks from the Services.',
  termsSection4Title: '4. User Security Responsibilities',
  termsSection4Intro: 'The User is responsible for maintaining the security and confidentiality of their account credentials and access information. The User must:',
  termsSection4Item1: 'keep all login credentials secure and confidential;',
  termsSection4Item2: 'not share account access with unauthorized individuals;',
  termsSection4Item3: 'immediately notify NoiseGrasp of any suspected security breach or unauthorized access to their account;',
  termsSection4Item4: 'be responsible for all activities that occur under their account.',
  termsSection5Title: '5. Ownership and Proprietary Rights',
  termsSection5Content1: 'NoiseGrasp owns and shall retain all right, title and interest (including without limitation all patent rights, copyrights, trademark rights, trade secret rights and other intellectual property rights), in and to the Services. The User agrees that only NoiseGrasp shall have the right to maintain, enhance or otherwise modify the Services.',
  termsSection5Content2: 'If the User provides NoiseGrasp with reports of defects in the Services or proposes or suggests any changes or modifications (collectively "Feedback"), NoiseGrasp shall have the right to use and exploit such Feedback including, without limitation, the incorporation of such Feedback into NoiseGrasp\'s software products and/or services, including, without limitation, the Services, without any obligation to the User. NoiseGrasp reserves all rights and grants the User no licenses of any kind, whether by implication, estoppel, or otherwise.',
  termsSection6Title: '6. Commercial Use',
  termsSection6Content: 'These Services are provided for commercial use by employees of companies that have contracted with NoiseGrasp. These Terms & Conditions are part of a broader contract signed between the companies and NoiseGrasp.',
  termsSection7Title: '7. Data Privacy',
  termsSection7Intro: 'NoiseGrasp is committed to protecting User privacy. Our data collection practices are minimal and limited to:',
  termsSection7Item1: 'User email addresses and names, which serve only as identification;',
  termsSection7Item2: 'essential cookies necessary for the proper functioning of the Services;',
  termsSection7Item3: 'no personal information tracking or behavioral monitoring;',
  termsSection7Item4: 'no use of tracking cookies or personal data collection beyond what is necessary for system operation.',
  termsSection7Content: 'All data uploaded and processed through the Services is handled in accordance with applicable data protection regulations.',
  termsSection8Title: '8. Limitations',
  termsSection8Content1: 'NoiseGrasp commits to providing services with due care, diligence, and adherence to industry best practices and standards. However, it is explicitly stated that the models and deliverables resulting from data analysis provided by the User and/or its company are derived from estimates and the application of intricate mathematical models. The conclusions and results obtained from these models are not guaranteed.',
  termsSection8Content2: 'Furthermore, NoiseGrasp asserts that all mathematical models furnished to its clients are estimations based on data and mathematical algorithms. No guarantees or warranties, either express or implied, are made regarding the suitability of these models to achieve any specific outcome. NoiseGrasp disclaims any responsibility for the accuracy or reliability of results obtained through the utilization of its mathematical models. The User acknowledges that any reliance on such results is at its own risk.',
  termsSection8Content3: 'In turn, the User acknowledges that the use of mathematical models inherently involves uncertainties and potential variations in results. Moreover, the User agrees to utilize the models at its own risk, understanding that NoiseGrasp shall not be held liable for any consequences arising from such use.',
  termsSection9Title: '9. Modifications',
  termsSection9Content: 'By using the Services, the User is agreeing to be bound by these Terms and Conditions of Use. If Terms and Conditions change in the future, this notice will be updated accordingly.',
  termsLastUpdated: 'Last updated: 15/07/2025',
  acceptTerms: 'Accept Terms & Conditions',
  close: 'Close',

  // What's New Dialog
  whatsNew: "What's New",
  posted: 'Posted {time}',
  previous: 'Previous',
  next: 'Next',
  ofCount: '({current} of {total})',

  // Model Selection Dialog
  modelSelection: 'Model Selection',
  allCountries: 'All countries',
  countriesSelected: '{count} of {total} countries selected',
  filterByCountry: 'Filter by Country',
  searchCountries: 'Search countries',
  selectAll: 'Select All',
  selectAllVisible: 'Select All Visible ({count})',
  allBrands: 'All brands',
  brandsSelected: '{count} of {total} brands selected',
  filterByBrand: 'Filter by Brand',
  searchBrands: 'Search brands',
  allClients: 'All clients',
  clientsSelected: '{count} of {total} clients selected',
  filterByClient: 'Filter by Client',
  searchClients: 'Search clients',
  allCategories: 'All categories',
  categoriesSelected: '{count} of {total} categories selected',
  filterByCategory: 'Filter by Category',
  searchCategories: 'Search categories',
  allSubcategories: 'All subcategories',
  subcategoriesSelected: '{count} of {total} subcategories selected',
  filterBySubcategory: 'Filter by Subcategory',
  searchSubcategories: 'Search subcategories',
  search: 'Search',
  adHocModels: 'AD-HOC MODELS',
  customModels: 'CUSTOM MODELS',
  select: 'Select',
  deployed: 'Deployed',
  notAvailable: 'N/A',

  // Table Headers
  headerModelName: 'Model Name',
  headerBrand: 'Brand',
  headerCountry: 'Country',
  current: 'current',
  versionDeployed: 'Deployed on {date}',
  headerClient: 'Client',
  headerCategory: 'Category',
  headerSubcategory: 'Subcategory',
  headerReference: 'Reference',
  headerDateCreated: 'Date Created',
  headerDateModified: 'Date Modified',
  headerCreatedBy: 'Created by',

  // Navigation Menu
  currentModel: 'Current Model',
  home: 'Home',
  modelSetup: 'Model Setup',
  dataUpload: 'Data Upload',
  dataCheck: 'Data Check',
  modelingProcess: 'Modeling Process',
  modelReport: 'Model Report',
  modelOverview: 'Model Overview',
  whatIfScenario: 'What-If Scenario',
  mediaPlanner: 'Media Planner',
  planCalculator: 'Plan Calculator',
  planOptimizer: 'Plan Optimizer',
  budgetSimulator: 'Budget Simulator',
  documents: 'Documents',
  admin: 'Admin',
  users: 'Users',
  refModels: 'Ref. Models',
  adHocModelsMenu: 'Ad-Hoc Models',
  countries: 'Countries',
  news: 'News',
  pendingPlans: 'Pending Plans',
  aiReviews: 'AI Reviews',
  errorLogs: 'Error Logs',
  automaticModels: 'DIY Models',
  automaticModeler: 'DIY Modeler',
  modelFactory: 'Model Factory',
  modelComposer: 'Model Composer',
  ekrmManager: 'EKRM Manager',
  userManager: 'User Manager',
  modelManager: 'Model Manager',
  learningCenter: 'Learning Center',
  stats: 'Stats',
  tools: 'Tools',
  logout: 'Logout',

  // Notifications
  clearAllNotifications: 'Clear all notifications',
  mediaPlanReady: 'Media Plan is ready',
  modelReportReady: 'Model Report is ready',
  ekrmReady: 'EKRM is ready',
  whatIfScenarioReady: 'What-If Scenario is ready',
  budgetSimulationReady: 'Budget Simulation is ready',
  noUnreadNotifications: 'No unread notifications',

  // Login Screen
  login: 'Login',
  email: 'E-mail',
  password: 'Password',
  loginWithGoogle: 'Login with Google',

  // Loading States
  loading: 'Loading...',
  authenticatingUser: 'Authenticating user...',
  clickToSignIn: 'Click here to sign in using Lion Login',

  // Validation Messages
  required: 'Required.',
  wrongPassword: 'Wrong password',
  passwordsMustMatch: 'New passwords must match',
  passwordMustBeDifferent: 'New password must be different that the old one',
  passwordRequirements: 'Password Must be Over 12 Characters, and must contain numeric, lowercase, uppercase, and special characters (#, ?, !, @, $, %, ^, *, -)',

  // Alert Messages
  passwordSetSuccessfully: 'Password set successfully',
  internalError: 'Internal error, please contact the system admin. Error code: ',

  // Time Ago
  justNow: 'just now',
  yearsAgo: '{count} year ago | {count} years ago',
  monthsAgo: '{count} month ago | {count} months ago',
  daysAgo: '{count} day ago | {count} days ago',
  hoursAgo: '{count} hour ago | {count} hours ago',
  minutesAgo: '{count} minute ago | {count} minutes ago',
  secondsAgo: '{count} second ago | {count} seconds ago',

  // Driver.js Intro Tour
  introCurrentModelTitle: 'Current Model',
  introCurrentModelDesc: 'Select which Custom Model to use for working with the Model Report and Online Simulator.',
  introModelReportTitle: 'Model Report',
  introModelReportDesc: 'See a report showing estimated Marketing Spend and KPI for the for the Current Model. This report is calculated based on the Reference Model specified on model creation.',
  introMediaPlannerTitle: 'Media Planner',
  introMediaPlannerDesc: 'Run Simulations and Optimizations. See Simulated KPI, and Optimized KPI for the specified: Period, Budget, Media/Touchpoint Constraints, and Segment Priorities.',
  introModelManagerTitle: 'Model Manager',
  introModelManagerDesc: 'Create Custom Models based on any of the available Reference Models and on client-specific data used for tunning them.',
  introModelDeletedTitle: 'Model Deleted',
  introModelDeletedDesc: 'The model you had selected has just been deleted. Please select another one.',

  // Footer Copyright
  poweredBy: 'Powered by ',
  allRightsReserved: 'All rights reserved - '
}
